export default __webpack_public_path__ + "static/media/calendarIcon.04d2571f.svg";